import React, { useEffect, useState } from 'react';
import { fetchTenantInfo, signout, updateTenant } from '@v10-codeparva/v10-tfw-revamp-package-api';
import { getIndivCookie, deleteCookie } from '../../../utils/auth';
import { TenantForm } from '../tenanatForm/TenanatForm';
import { Spinner } from '@chakra-ui/react';
import { navigate } from '@reach/router';

const navigateTo = (route: string) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathSegments = currentPath.split('/');
    // Keep only the segments up to and including "pay-rent"
    const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
    navigate(`${basePath}/${route}`);
};

export const TenantUpdatePage = ({ location }: { location: any }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [apiResponse, setApiResponse] = useState<any>();
    const cToken = getIndivCookie('cToken');

    useEffect(() => {
        let unMounted = false;
        async function fetchDetails() {
            const requestBody = {
                token: cToken || '',
                cid: process.env.CID || '',
            }
            const tenantDetails = await fetchTenantInfo(requestBody);
            const {
                Tenant
            } = tenantDetails;
            const responseState = {
                Tenant
            };
            setApiResponse(responseState);
            setIsLoading(false);
        }


        try {
            if (!unMounted) {
                fetchDetails()
            }
        } catch (e) {
            if (!unMounted) {
                console.error(e)
            }
        }
    }, [])

    const signOutHandler = async () => {
        const requestBody = {
            token: cToken || '',
            cid: process.env.CID || '',
        }
        const signOutResponse = await signout(requestBody);
        const {
            blnSuccess
        } = signOutResponse;
        if (blnSuccess) {
            deleteCookie('cToken');
            navigateTo('payment')
        }
    };

    const updateTenantDetails = async (formProps: any) => {
        const {
            values
        } = formProps;
        const tenantUpdateRequest = {
            tenantInfo: values,
            token: cToken,
            cid: process.env.CID || '',
        };
        const updateTenantResponse = await updateTenant(tenantUpdateRequest);
        const {
            blnSuccess
        } = updateTenantResponse;
        if (blnSuccess) {
            const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
            const pathSegments = currentPath.split('/');
            // Keep only the segments up to and including "pay-rent"
            const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
            navigate(`${basePath}/update-tenant-success`, {
                state: {
                    message: 'Tenant Details Updated'
                }
            })
        }
    }

    const RenderComponent = () => {
        const tenantUpdateProps = {
            FirstName: apiResponse.Tenant.FirstName,
            LastName: apiResponse.Tenant.LastName,
            Phone: apiResponse.Tenant.Phone,
            EmailAddress: apiResponse.Tenant.EmailAddress,
            AddressLine1: apiResponse.Tenant.AddressLine1,
            AddressLine2: apiResponse.Tenant.AddressLine2,
            City: apiResponse.Tenant.City,
            State: apiResponse.Tenant.State,
            ZIP: apiResponse.Tenant.ZIP,
            logOffHandler: signOutHandler,
            updateTenantFormHandler: updateTenantDetails
        };
        return <TenantForm {...tenantUpdateProps} />
    }

    return (
        <>
            {
                isLoading ? <Spinner size={'xl'} /> : <RenderComponent />
            }
        </>
    )

};